var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgButtonArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -0.3 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.785h12.621",
    "data-name": "Line 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.081.703l6.919 7-6.919 7",
    "data-name": "Path 16"
  }))));
}

export default __webpack_public_path__ + "884cbed45f6e6ade11638851e135eba6.svg";
export { SvgButtonArrow as ReactComponent };